import template from './loansSignUpFormLegalConditions.html';
import controller from './loansSignUpFormLegalConditions.controller';
import './loansSignUpFormLegalConditions.scss';

let loansSignUpFormLegalConditionsComponent = {
  restrict: 'E',
  bindings: {
    onAcceptLegalConditions: '&',
    loanPurposeText: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansSignUpFormLegalConditionsComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpFormLegalConditions/loansSignUpFormLegalConditions.component.js